firebird.factory('routerService', [
    '$q',
    '$location',
    '$rootScope',
    '$state',
    '$window',
    '$http',
    'helperService',
    'meetingAPIService',
    'logService',
    'analyticsWrapperService',
    'storageService',
    'audioFileService',
    'attendeeService',
    'cookieService',
    'brandingStateService',
    'authService',
    function (
        $q,
        $location,
        $rootScope,
        $state,
        $window,
        $http,
        helperService,
        meetingAPIService,
        logService,
        analyticsWrapperService,
        storageService,
        audioFileService,
        attendeeService,
        cookieService,
        brandingStateService,
        authService
    ) {
        const logger = logService.createLoggerWithSource('routerService');
        const webinarType = 3;

        var service = {
            resolveInitialPath: resolveInitialPath,
            setActiveMeetingState: setActiveMeetingState,
            setEndMeetingState: setEndMeetingState,
            setMeetingAlreadyEndedState: setMeetingAlreadyEndedState,
            setStateForKicked: setStateForKicked,
            setAppOrBrowserNotSupportedState: setAppOrBrowserNotSupportedState,
            setCamaroUpdatingState: setCamaroUpdatingState,
            setLoadingState: setLoadingState,
            setMobileView: setMobileView,
            setMeetingErrorState: setMeetingErrorState,
            setAlreadyEndedState: setAlreadyEndedState,
            refreshPage: refreshPage,
            goToAccountManager: goToAccountManager,
            setMeetingFullState: setMeetingFullState,
            setE2EEMeetingFullState: setE2EEMeetingFullState,
            setMeetingLockedState: setMeetingLockedState,
            setJoinRequestDeclinedState: setJoinRequestDeclinedState,
            setUniteDuplicateLoginState: setUniteDuplicateLoginState,
            setMeetingLoginState: setMeetingLoginState,
            setWebviewCaptureState: setWebviewCaptureState,
            reloadCurrentState: reloadCurrentState,
            setChangeBrowserState: setChangeBrowserState,
            setMobileHostAccountView: setMobileHostAccountView,
            setMobileHostLoginView: setMobileHostLoginView,
            setCustomMeetingState: setCustomMeetingState,
            setNotStartedState: setNotStartedState,
            canJoinBeforeHost: canJoinBeforeHost,
            joinBeforeHost: joinBeforeHost,
            shouldShowClientNotSupported: shouldShowClientNotSupported
        };

        return service;

        ////////////////////////

        function setMobileHostAccountView() {
            $state.go('host-account-page');
            helperService.setMobileHostLoggedIn(true);
            var isTablet = helperService.isTablet();
            var isMobile = helperService.isMobile();
            if (isMobile && !isTablet) {
                helperService.lockOrientation('portrait');
            }
        }

        function setMobileHostLoginView() {
            $state.go('mobile-host-login');
            helperService.setMobileHostLoggedIn(false);
            var isTablet = helperService.isTablet();
            var isMobile = helperService.isMobile();
            if (isMobile && !isTablet) {
                helperService.lockOrientation('portrait');
            }
        }

        function resolveInitialPath(meetingIdentifier) {
            let deferred = $q.defer();

            if (helperService.isValidMeetingCode(meetingIdentifier)) {
                logger.info(`#resolveInitialPath: Get by meeting code: ${meetingIdentifier}`);
                meetingAPIService
                    .getMeetingDetailsByCode({
                        meetingCode: meetingIdentifier
                    })
                    .then(meeting => {
                        service.setCustomMeetingState(meeting, false, deferred);
                    })
                    .catch(err => {
                        setNotFoundState('invalid-meeting-code');
                        deferred.reject(err);
                    });
            } else if (helperService.isValidShortcut(meetingIdentifier)) {
                logger.info(`#resolveInitialPath: Get by shortcut URL: ${meetingIdentifier}`);
                meetingAPIService
                    .getMeetingDetailsByShortcut({
                        meetingShortcutURL: meetingIdentifier
                    })
                    .then(meeting => {
                        service.setCustomMeetingState(meeting, true, deferred);
                    })
                    .catch(err => {
                        switch (err.message) {
                            case 'There is no active meeting for the given event key':
                                if (service.shouldShowClientNotSupported()) {
                                    service.setAppOrBrowserNotSupportedState();
                                } else {
                                    setNotFoundState('inactive-shortcut-url', err.data);
                                }
                                deferred.reject(err);
                                break;
                            default:
                                setNotFoundState('invalid-shortcut-url', err.data);
                                deferred.reject(err);
                                break;
                        }
                    });
            } else if (meetingIdentifier === '') {
                setNotFoundState('no-meeting-code');
                deferred.reject('No meeting code');
            } else {
                setNotFoundState('invalid-shortcut-url');
                deferred.reject('Could not resolve path');
            }

            return deferred.promise;
        }

        function setMobileView(appUpdateStatus) {
            //TODO: Make separate view for app update status page?
            if (appUpdateStatus && appUpdateStatus.type === 'mandatory') {
                $state.go('meeting-login', { appUpdateStatus: appUpdateStatus });
                analyticsWrapperService.eventTrack('Meeting - Meeting State - Mandatory Update');
                return;
            }

            storageService.clearTimedKeyOlderThanDays('aat', 30);

            //this to work around an android issue where when logged out and force quit
            //the app still retains the token in cookie
            var value = $window.JSON.parse(storageService.get('aat'));
            var token;
            if (value) {
                token = value.token;
            } else {
                cookieService.remove('aat');
            }

            var env = cookieService.get('mobile-env') || 'anymeeting.com';

            if (!token) {
                logger.info('#setMobileView: Entering Mobile Host Login');
                helperService.setMobileHostLoggedIn(false);
                $state.go('mobile-host-login');
            } else {
                helperService.setMobileLocation(env);
                helperService.setMobileHostLoggedIn(true);
                $http.defaults.headers.common.Authorization = 'Bearer ' + token;
                logger.info('#setMobileView: Entering Mobile Host account page');
                $state.go('host-account-page');
            }

            var isTablet = helperService.isTablet();
            var isMobile = helperService.isMobile();

            if (isMobile && !isTablet) {
                helperService.lockOrientation('portrait');
            }
        }

        function setActiveMeetingState() {
            $state.go('meeting-active.attendee-list', { templatePrefix: helperService.getRedesignPathPrefix() });
            analyticsWrapperService.eventTrack('Meeting - Meeting State - Active');

            if (helperService.isMobile()) {
                helperService.lockOrientation('landscape');
            }
        }

        function setEndMeetingState(options) {
            if (helperService.isMobile()) {
                $state.go('meeting-ended-thank-you', { templatePrefix: helperService.getRedesignPathPrefix() });
                analyticsWrapperService.eventTrack('Meeting - Meeting State - Ended (Thank You)');

                setTimeout(function () {
                    var isTablet = helperService.isTablet();
                    var deviceType = helperService.getDeviceType();
                    if (isTablet) {
                        helperService.unlockOrientation();
                    } else if (deviceType == 'iPhone') {
                        //first change orientation to landscape first because setting it to portrait mode
                        //first does not seem to work
                        helperService.lockOrientation('landscape');
                        helperService.lockOrientation('portrait');
                    }
                    $window.location.reload();
                }, 1000);
            } else {
                if (options && options.reason) {
                    switch (options.reason) {
                        case 'e2ee':
                            $state.go('e2ee-key-was-not-provided', {
                                templatePrefix: helperService.getRedesignPathPrefix()
                            });
                            break;
                        default:
                            break;
                    }
                } else {
                    $state.go('meeting-ended-thank-you', { templatePrefix: helperService.getRedesignPathPrefix() });
                }
                analyticsWrapperService.eventTrack('Meeting - Meeting State - Ended (Thank You)');
            }
        }

        function setMeetingAlreadyEndedState() {
            setAlreadyEndedState();
        }

        function setStateForKicked(options) {
            if (options && options.reason) {
                switch (options.reason) {
                    case 'e2ee':
                        $state.go('phone-audio-not-supported', {
                            templatePrefix: helperService.getRedesignPathPrefix()
                        });
                        break;
                    case 'e2ee-not-supported':
                        $state.go('e2ee-not-supported', { templatePrefix: helperService.getRedesignPathPrefix() });
                        break;
                    case 'e2ee-not-supported-vdi':
                        $state.go('e2ee-not-supported-vdi', { templatePrefix: helperService.getRedesignPathPrefix() });
                        break;
                    default:
                        break;
                }
            } else {
                $state.go('kicked-from-meeting', { templatePrefix: helperService.getRedesignPathPrefix() });
            }

            var deviceType = helperService.getDeviceType();

            if (helperService.isMobile()) {
                setTimeout(function () {
                    if (deviceType == 'iPhone') {
                        helperService.lockOrientation('portrait');
                    }

                    $window.location.reload();
                }, 5000);
            }
        }

        function setMeetingErrorState() {
            $state.go('meeting-error', { templatePrefix: helperService.getRedesignPathPrefix() });
            analyticsWrapperService.eventTrack('Meeting - Meeting State - Error');
        }

        function setAppOrBrowserNotSupportedState() {
            applyRedesign();
            $state.go('app-or-browser-not-supported');
            analyticsWrapperService.eventTrack('Meeting - Meeting State - App or Browser Not Supported');
            logger.info('#setAppOrBrowserNotSupportedState: Meeting client or browser not supported');
        }

        function setCamaroUpdatingState() {
            applyRedesign();
            $state.go('camaro-updating');
            analyticsWrapperService.eventTrack('Meeting - Meeting State - camaro-updating');
            logger.info('#setCamaroUpdatingState: Camaro updating');
        }

        function setLoadingState() {
            $state.go('loading', { templatePrefix: helperService.getRedesignPathPrefix() });
            analyticsWrapperService.eventTrack('Meeting - Meeting State - Loading');
        }

        function setWebviewCaptureState(webviewCaptureParams) {
            webviewCaptureParams.templatePrefix = helperService.getRedesignPathPrefix();
            $state.go(webviewCaptureParams.destination + '-' + webviewCaptureParams.type, webviewCaptureParams);
            logger.info('#setWebviewCaptureState: Capturing Webview screen for recording backdrop');
        }

        function setMeetingFullState(data) {
            $state.go('meeting-full', {
                seats: data.seats,
                phoneNumber: data.phoneNumber,
                pin: data.attendeePIN,
                templatePrefix: helperService.getRedesignPathPrefix()
            });
            analyticsWrapperService.eventTrack('Meeting - Meeting State - Full');
        }

        function setE2EEMeetingFullState(data) {
            $state.go('e2ee-meeting-full', {
                seats: data.seats,
                templatePrefix: helperService.getRedesignPathPrefix()
            });
            analyticsWrapperService.eventTrack('Meeting - E2EE Meeting State - Full');
        }

        function setMeetingLockedState(data) {
            if (data.allowJoinRequests === true) {
                $state.go('meeting-locked-waiting-for-approval', {
                    templatePrefix: helperService.getRedesignPathPrefix()
                });
                analyticsWrapperService.eventTrack('Meeting - Meeting State - Locked - WaitingForApproval');

                // request access for desktop notification in case browser would not be in focus
                helperService.tryRequestDesktopNotificationPermission();
            } else {
                // SBELIKOV_TODO: join requests are not allowed => need to show new UI here (create another state, ex: meeting-locked-join-requests-not-allowed)
                // Should we create new analytics event for join requests are not allowed?
                $state.go('meeting-locked', { templatePrefix: helperService.getRedesignPathPrefix() });
                analyticsWrapperService.eventTrack('Meeting - Meeting State - Locked');
            }
        }

        function setJoinRequestDeclinedState(data) {
            $state.go('meeting-locked-join-request-declined', {
                templatePrefix: helperService.getRedesignPathPrefix()
            });
            analyticsWrapperService.eventTrack('Meeting - Meeting State - Join Request Declined');
        }

        function setUniteDuplicateLoginState() {
            $state.go('meeting-unite-duplicate-login', { templatePrefix: helperService.getRedesignPathPrefix() });
            analyticsWrapperService.eventTrack('Meeting - Meeting State - Unite Duplicate Login');
        }

        function refreshPage() {
            $window.location.reload();
        }

        function setMeetingLoginState(params, opts) {
            if (!params) {
                params = {};
            }
            params.templatePrefix = helperService.getRedesignPathPrefix();
            $state.go('meeting-login', params, opts);
            analyticsWrapperService.eventTrack('Meeting - Meeting State - Login');
        }

        function goToAccountManager() {
            var domain = helperService.getLocationHost();
            var protocol = helperService.getLocationProtocol();
            $window.location.href = protocol + '://' + domain + '/AccountManager';
        }

        function reloadCurrentState() {
            $state.reload();
        }

        function setChangeBrowserState(meetingCode, presenterGUID) {
            var params = {
                meetingCode: meetingCode,
                presenterGUID: presenterGUID
            };

            $state.go('change-browser', params);
            analyticsWrapperService.eventTrack('Meeting - Meeting State - Change Browser');
        }

        function setAlreadyEndedState() {
            if (helperService.isMobile()) {
                helperService.mobileAlert("We're sorry, that meeting has already ended.", 'Meeting Has Ended');
            } else {
                $state.go('meeting-ended', { templatePrefix: helperService.getRedesignPathPrefix() });
                analyticsWrapperService.eventTrack('Meeting - Meeting State - Ended');
            }
        }

        function setShowElectronState() {
            $state.go('meeting-show-electron', { templatePrefix: helperService.getRedesignPathPrefix() });
            analyticsWrapperService.eventTrack('Meeting - Meeting State - Show Electron');
        }

        function setNotStartedState(meeting, skipJoinBeforeHost) {
            $state.go('meeting-not-started', {
                data: { meetingInfo: meeting, skipJoinBeforeHost: skipJoinBeforeHost },
                templatePrefix: helperService.getRedesignPathPrefix()
            });
            analyticsWrapperService.eventTrack('Meeting - Meeting State - Not Started');
        }

        function setErrorState() {
            $state.go('meeting-error', { templatePrefix: helperService.getRedesignPathPrefix() });
            analyticsWrapperService.eventTrack('Meeting - Meeting State - Error');
        }

        //Private Function
        function trySetLoginState(meeting, deferred) {
            if (shouldShowClientNotSupported()) {
                service.setAppOrBrowserNotSupportedState();
                deferred.resolve(meeting);
                return;
            }

            if (helperService.shouldUseMobileRedirect()) {
                return;
            }

            if (!meeting.meetingServerURI) {
                setErrorState();

                return;
            }

            // In case of mobile: we don't show login screen to identify if user allowed to join.
            // if there is no cookie we say "Meeting is locked" instead of login screen.
            if (
                helperService.isMobile() &&
                meeting.locked &&
                !attendeeService.getIsHost() &&
                !cookieService.getObject('userCache')
            ) {
                helperService.mobileAlert(
                    'Contact ' + meeting.hostDisplayName.split(' ')[0] + ' to unlock the meeting.',
                    'Meeting is locked'
                );
                deferred.reject('Meeting Has Ended');

                return;
            }

            //if the config is enabled, take non webrtc browsers to the electron/download detection page
            //TODO: pick the right helper Service function here.  The current logic is taken from
            //what is in the meeting login controller to show warning ... but something more like "hasWebrtc"
            //seems like a better function
            if (helperService.isElectronSupportedPlatform() && !helperService.isElectron()) {
                setSkipAppDetection(meeting);
                // crossbrowser compatibility check.
                // TODO: following should be replaced eventually by just browserHasWebRTC.
                // For now, the isChrome code is kept here for compatibility with old code without enableBrowser query param.

                if (!isChromeOrHasWebRTC() || meeting.launchApp) {
                    tryPlayMeetingLoginChime();
                    setShowElectronState();

                    return;
                }
            }

            $state.go('meeting-login', { templatePrefix: helperService.getRedesignPathPrefix() });
            tryPlayMeetingLoginChime();
            analyticsWrapperService.eventTrack('Meeting - Meeting State - Login');
        }

        //Private Function
        function isChromeOrHasWebRTC() {
            let isSupported = helperService.isChrome();
            if (helperService.getQueryParameter('enableBrowser') == 'true') {
                isSupported = helperService.browserHasWebRTC();
            }

            if (!isSupported) {
                logger.info('#isChromeOrHasWebRTC: browser not supported, redirecting to electron detection screen');
            }

            return isSupported;
        }

        function shouldShowClientNotSupported() {
            return !helperService.isMobileDevice() && !helperService.isSupportedClient();
        }

        //Private Function
        function getLocation(meeting) {
            return (
                helperService.getLocationProtocol() +
                '://www.' +
                helperService.getLocationHost() +
                '/' +
                meeting.meetingCode
            );
        }

        //Private Function
        function setStateBySessionStatus(meeting, deferred) {
            switch (meeting.sessionStatusID) {
                case 2: //meeting active
                    trySetLoginState(meeting, deferred);
                    break;
                case 3: //meeting ended
                case 4: //meeting archived
                    if (meeting.upcomingEventTimes && meeting.upcomingEventTimes.length) {
                        $window.location = getLocation(meeting);
                    } else {
                        setAlreadyEndedState();

                        if (helperService.isMobile() || helperService.shouldUseMobileRedirect()) {
                            deferred.reject('Meeting Has Ended');
                        }
                    }

                    break;
                default:
                    logger.warn(`#setStateBySessionStatus: unexpected session status: ${meeting.sessionStatusID}`);
            }
        }

        //Private Function
        function setSkipAppDetection(data) {
            if (data.launchApp !== undefined && data.launchApp === false) {
                return data;
            }

            const skipAppDetectionParam = helperService.getQueryParameter('skipAppDetection');
            if (skipAppDetectionParam && helperService.isChrome()) {
                data.launchApp = false;
            }

            if (data.meetingType === webinarType && helperService.isChrome()) {
                data.launchApp = false;
            }

            // if enableBrowser is desired, then do not launch/check app.
            if (helperService.getQueryParameter('enableBrowser') == 'true') {
                data.launchApp = false;
            }

            if (helperService.isUniteWeb()) {
                data.launchApp = false;
            }

            return data;
        }

        //Private Function
        function setCustomMeetingState(meeting, skipJoinBeforeHost, deferred) {
            brandingStateService.resellerId = meeting.resellerId;

            applyRedesign(meeting);

            if (helperService.isCamaro()) {
                service.setCamaroUpdatingState();
                deferred.resolve(meeting);
                return;
            }

            if (meeting && meeting.meetingStarted === false) {
                if ($window.cordova) {
                    helperService.mobileAlert("We're sorry, that meeting has not yet started.", 'Meeting Not Started');
                    deferred.reject('Meeting Not Started');
                } else {
                    if (helperService.shouldUseMobileRedirect()) {
                        deferred.resolve(meeting);
                        return;
                    }

                    setSkipAppDetection(meeting);

                    if (!skipJoinBeforeHost && service.canJoinBeforeHost(meeting)) {
                        service.joinBeforeHost(meeting, deferred);
                        return;
                    } else {
                        logger.info('#setCustomMeetingState: Cannot join meeting before host');
                        service.setNotStartedState(meeting, false);
                    }
                }
            } else if (meeting && meeting.sessionStatusID) {
                setStateBySessionStatus(meeting, deferred);
            } else {
                //meeting not found means we shouldn't have a user with a user pair, but we're going to send this info anyways for the redesign
                $state.go('meeting-not-found', { templatePrefix: helperService.getRedesignPathPrefix() });
                analyticsWrapperService.eventTrack('Meeting - Meeting State - Not Found');
            }

            //even if deferred with promise was rejected above, its state will not change after call resolve
            deferred.resolve(meeting);
        }

        function joinBeforeHost(meeting, deferred) {
            logger.info('#joinBeforeHost: Starting to try join meeting before host');

            const data = { hashedPassword: helperService.getQueryParameter('pwd') };
            meetingAPIService
                .joinBeforeHost(meeting.meetingCode, data)
                .then(result => {
                    logger.info('#joinBeforeHost: Successfully joined meeting before host', result);

                    if (!result.meetingWasActiveAlready) {
                        analyticsWrapperService.eventTrack('Meeting - JoinBeforeHost - StartedByAttendee');
                    }

                    service.setCustomMeetingState(result.meeting, true, deferred);
                })
                .catch(error => {
                    logger.error('#joinBeforeHost: Failed to join meeting before host', error);

                    const skipJoinBeforeHost = error?.message === 'skipJoinBeforeHost';
                    service.setNotStartedState(meeting, skipJoinBeforeHost);
                    // resolve promise because we'll use the meeting info in meetingNotStartedCtrl
                    deferred.resolve(meeting);
                });
        }

        function canJoinBeforeHost(meeting) {
            if (meeting.requiresPassword && !helperService.getQueryParameter('pwd')) {
                return false;
            }

            const authToken = authService.getAuthToken();

            return !!authToken && meeting.allowJoinBeforeHost;
        }

        function applyRedesign(meeting) {
            if (meeting && meeting.meetingType === webinarType) {
                logger.info('#applyRedesign: Redesign not enabled for Webinar');
                helperService.setIsRedesign(false);
                $rootScope.$broadcast('use-redesign', { isRedesign: false });
            } else {
                logger.info('#applyRedesign: Redesign enabled');
                helperService.setIsRedesign(true);
                $rootScope.$broadcast('use-redesign', { isRedesign: true });
            }
        }

        //Private Function
        function setNotFoundState(reason, data) {
            logger.info('#setNotFoundState: setting not found state', reason);

            if ($window.cordova) {
                var mobileAlertMsg = '',
                    mobileAlertTitle = '';

                switch (reason) {
                    case 'inactive-shortcut-url':
                        mobileAlertMsg = "We're sorry, there is currently no meeting active.";
                        mobileAlertTitle = 'Meeting Not Active';
                        break;
                    case 'invalid-meeting-code':
                    case 'invalid-shortcut-url':
                        mobileAlertMsg = "We're sorry, that meeting was not found.";
                        mobileAlertTitle = 'Meeting Not Found';
                        break;
                    case 'no-meeting-code':
                        mobileAlertMsg = "We're sorry, you did not enter a meeting code.";
                        mobileAlertTitle = 'No Meeting Code';
                        break;
                    default:
                        logger.log('setNotFoundState', 'unexpected reason', reason);
                }

                helperService.mobileAlert(mobileAlertMsg, mobileAlertTitle);
            } else {
                if (data) {
                    setSkipAppDetection(data);
                }

                applyRedesign();
                $state.go('meeting-not-found', {
                    reason: reason,
                    data: data,
                    templatePrefix: helperService.getRedesignPathPrefix()
                });

                analyticsWrapperService.eventTrack('Meeting - Meeting State - Not Found');
            }
        }

        function tryPlayMeetingLoginChime() {
            var waitingForMeeting = helperService.getQueryParameter('waitingForMeeting');
            if (waitingForMeeting) {
                $location.search('waitingForMeeting', null);
                audioFileService.playMeetingLoginChime();
            }
        }
    }
]);
